// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@5.2.7_webpack@5.76.1/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#floating-whatsapp[data-v-3baf4f0f]{background:#00ff5f;background:linear-gradient(180deg,#00ff5f 0,#25d366);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00ff5f\",endColorstr=\"#25d366\",GradientType=0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
